export default __webpack_public_path__ + "static/media/swl_24h.7a19e232.png";